import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityDigital/img/1.avif';
import image2 from '@src/assets/images/solution/cityDigital/img/2.avif';
import image3 from '@src/assets/images/solution/cityDigital/img/3.avif';
import image4 from '@src/assets/images/solution/cityDigital/img/4.avif';
import image5 from '@src/assets/images/solution/cityDigital/img/5.avif';
import image6 from '@src/assets/images/solution/cityDigital/img/6.avif';
import image7 from '@src/assets/images/solution/cityDigital/img/7.avif';
import image8 from '@src/assets/images/solution/cityDigital/img/8.avif';

export default {
  type: 'City Solution',

  banner: {
    title: 'Real-time City-wide Monitoring and Digital Disaster Response System',
    desc: 'Visualize urban spatial data with a 3D digital twin to predict, respond to, and recover from disasters, providing an integrated management platform for pre- and post-disaster scenarios.',
  },

  // video: {
  //   title: 'Connect All Disaster Management Processes in Real-time with a Digital Twin',
  //   desc: 'Recreate the actual city in a virtual space and integrate various real-time data such as sensors, location information, and camera footage to operate early warning, response during disasters, and post-recovery as a unified system.',
  //   play: video,
  // },

  func: [
    {
      theme: 'Integrated Urban Disaster Information and Real-time Visualization',
      title: 'Integrated Monitoring Based on Urban Infrastructure',
      desc: 'Manage various city infrastructure data required for disaster response on a single platform. Integrate road, river, facility, and sensor data to check risk factors across the entire city in real-time.',
      sub1: 'Real-time Status Monitoring',
      icon1: IconClockGray,
      sub2: 'Fast Data Integration',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'Real-time Weather Data Collection and Analysis',
      desc: 'Collect satellite images, weather charts, and radar data in real-time, providing predictive and alert systems for severe weather. Quantify the city’s weather environment for scenario-based response plans.',
      sub1: 'Designate Risk Assets',
      icon1: IconWarningGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image2,
    },
    {
      title: 'Check Regional Rainfall Status in Real-time',
      desc: 'Collect and analyze rainfall data for each area in real-time using installed rain gauges. Prioritize response to affected areas during heavy rain.',
      sub1: 'Provide Statistical Data',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: 'Visualize River Water Level and Flow Status',
      desc: 'Visualize the water level, flow, and gate status of major rivers like the Nakdong River and Naeseongcheon in real-time. Automatically detect abnormal levels and send risk alerts.',
      sub1: 'Provide Statistical Data',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: 'Disaster Response Automation and Control Room Utilization',
      title: 'Alarm Integration Based on Comprehensive Situations',
      desc: 'Aggregate various data and display risks clearly on the control room screens. Automatically execute customized alerts and response triggers based on situation-specific decision criteria.',
      sub1: 'Provide Statistical Data',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: 'Control Room Display Configuration and Real-time Display',
      desc: 'In the disaster control room, CCTV, alert history, and major river water levels are displayed on large screens for real-time monitoring. The dedicated layout enhances on-site responsiveness and allows quick sharing of the overall disaster status.',
      sub1: 'Provide Statistical Data',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: 'Remote Response System During Disasters',
      desc: 'In the event of a disaster, immediate actions can be taken remotely such as broadcasting village alerts via TTS, sending SMS, monitoring CCTV footage, and controlling remote circuit breakers.',
      sub1: 'Provide Statistical Data',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: 'Multi-panel Data Visualization',
      desc: 'Provides a data panel integrating weather information, water level, rainfall, and alert indicators. Compare and judge various environmental information intuitively on a single screen, accelerating situational awareness and decision-making.',
      sub1: 'Provide Statistical Data',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: 'Various Features',
    desc: 'Medical waste must be managed with constant vigilance. Even small negligence or mistakes can lead to major medical incidents. Therefore, very precise and secure management is required.<br/>ORBRO provides various functions to build a safe and efficient medical facility.',

    data: [
      {
        icon: IconDashboard,
        title: 'Citywide Monitoring',
        desc: 'Manage roads, rivers in one place.',
      },
      {
        icon: IconClockGray,
        title: 'Live Weather Data',
        desc: 'Radar & satellite shown live.',
      },
      {
        icon: IconChartBarGray,
        title: 'Rainfall Analysis',
        desc: 'Auto analyze rain by area.',
      },
      {
        icon: IconChartBarGray,
        title: 'River Level Check',
        desc: 'Track river level & flow live.',
      },
      {
        icon: IconDashboard,
        title: 'Situation Board',
        desc: 'Show CCTV & sensors together.',
      },
      {
        icon: IconZoneGray,
        title: 'Multi-Screen View',
        desc: 'Split screens for each purpose.',
      },
      {
        icon: IconBell,
        title: 'Auto Alert',
        desc: 'Send alarms when rules met.',
      },
      {
        icon: IconSecurity,
        title: 'CCTV & Remote Ctrl',
        desc: 'View CCTV & control devices.',
      },
      {
        icon: IconRoute,
        title: 'Disaster Response',
        desc: 'Auto run scenario plans.',
      },
      {
        icon: IconChartRadius,
        title: 'Auto Log Save',
        desc: 'Save all history by default.',
      },
    ],
  },

  system: {
    title: 'System Configuration',
    img: rtlsSystem,
  },

  productTitle: 'Product Configuration',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'retailOffice' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
